// extracted by mini-css-extract-plugin
module.exports = {"miniCards":"mediaPromotion_miniCards__24XA7","mainCards":"mediaPromotion_mainCards__3r7Fg"};